<template>
    <div id="m-inbox" style="height: 100%">
        <v-card elevation="0">
            <v-card-actions style="height: 70px!important;">
                <v-tabs v-model="tab" class="no-transition">
                    <v-tab key="tab-t-u">Talks
                        <v-icon size="20" style="margin-left: 8px">mdi-chat-processing-outline</v-icon>
                    </v-tab>
                    <v-tab key="tab-explainers-u">Explainers
                        <v-icon size="20" style="margin-left: 8px">mdi-view-week-outline</v-icon>
                    </v-tab>
                    <v-tab key="tab-test-u">Test
                        <v-icon size="20" style="margin-left: 8px">mdi-asterisk</v-icon>
                    </v-tab>
                    <v-tab key="tab-heroes-u">Heroes
                        <v-icon size="20" style="margin-left: 8px">mdi-emoticon-happy</v-icon>
                    </v-tab>
                </v-tabs>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0 mx-2" style="border-bottom: green solid 0px;">
                <v-card width="100%" class="ma-0 pa-0 scroll" elevation="0" :height="winsize.height - 145">
                    <v-tabs-items class="mt-0" v-model="tab">
                        <v-tab-item
                                transition="fade-transition"
                                reverse-transition="fade-transition"
                                key="tab-t-u">
                            <utils-talks-page></utils-talks-page>
                        </v-tab-item>
                        <v-tab-item
                                transition="fade-transition"
                                reverse-transition="fade-transition"
                                key="tab-explainers-u">
                            <utils-explainers-page></utils-explainers-page>
                        </v-tab-item>
                        <v-tab-item
                                transition="fade-transition"
                                reverse-transition="fade-transition"
                                key="tab-test-u">
                            <utils-test-page></utils-test-page>
                        </v-tab-item>
                        <v-tab-item
                                transition="fade-transition"
                                reverse-transition="fade-transition"
                                key="tab-heroes-u">
                            <utils-heroes-page></utils-heroes-page>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import UtilsTalksPage from "@/modules/muiutils/views/utils-talks-page";
import UtilsExplainersPage from "@/modules/muiutils/views/utils-explainers-page";
import UtilsTestPage from "@/modules/muiutils/views/utils-test-page";
import UtilsHeroesPage from "@/modules/muiutils/views/utils-heroes-page.vue";
import HeroKindStore from "@/modules/mherokind/database/HeroKindStore";
import { WorkerKind } from "../redactor/models/worker/WorkerKind";

export default {
    components: {UtilsTalksPage, UtilsTestPage, UtilsExplainersPage, UtilsHeroesPage},
    data: () => ({
        tab: null,
        // header: [
        //     {text: 'Email', sortable: true, value: 'email', class: "white blue--text", color: "red"},
        //     {text: 'Uid', sortable: true, value: 'uid', class: "white blue--text", color: "red"},
        //     {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width:'20%', align:'end'}
        // ],
        loading: true,
        reloading:false,
        // message: "",
    }),
    computed:{
        winsize() {
            return window.app.winsize;
        }
        // frontendUsers(){
        //     return PermissionsStoreUtils.getUsers()
        // }
    },
    methods: {
        // ifCanEdit(){
        //     let userUid = PermissionsStoreUtils.getMyUserUid()
        //     return PermissionsStoreUtils.getPermission(userUid, PermissionsStoreUtils.PERMISSION_TAB.subpermissions.PERMISSION_TAB_EDIT.id)
        // },
        // onPressEdit(user){
        //     this.$refs['p-edit-permissions-popup'].show(user)
        // }
    },
    beforeMount() {
        //this.loading = false

        WorkerKind.fetchWorkerKinds().then(() => {
          console.log("Loaded successfully. worker-kind-store");
          if(!this.$store.hasModule(['hero-kind-store'])){
            this.$store.registerModule("hero-kind-store", HeroKindStore);
            this.$store.dispatch("hero-kind-store/init").then(() => {
                    console.log("Loaded successfully. hero-kind-store");
                    this.loading = true;
                }).catch(() => {
                    this.message = "Load failed!";
                }).finally(() => {
                    this.loading = false;
                });
            }
        }).catch(() => {
          console.error("Failed to load hero kinds.");
        });
    },
    destroyed() {
        console.log("destroy root view permissions");
    }
}
</script>

<style scoped>
</style>